import { FC } from 'react';

import { TableSection } from '../Table/Table.types';
import { TableHeadStyled } from './TableHead.styles';
import { TableHeadProps } from './TableHead.types';

import TableSectionContextProvider from '../Table/TableSectionContext';

const TableHead: FC<TableHeadProps> = ({ children }) => {
  return (
    <TableSectionContextProvider value={{ variant: TableSection.HEADER }}>
      <TableHeadStyled>{children}</TableHeadStyled>
    </TableSectionContextProvider>
  );
};

export default TableHead;
